import i18next from 'i18next';

i18next.addResources('es', 'customMenu', {
  sections: 'Secciones',
  actions: 'Acciones',
  'draft-actions': 'Acciones (borrador)',
  territories: 'Territorios',
  layers: 'Capas (Shapefiles)',
  parametricTables: 'Tablas paramétricas',
  priorizaciones: 'Priorizaciones',
  disclaimers: 'Disclaimers',
  studies: 'Estudios (menú)',
  etapas: 'Etapas',
  themes: 'Temas',
  subthemes: 'Subtemas',
  'chart-categories': 'Categorías de gráficos',
  'subtheme-categories': 'Subtemas por categoría',
  types: 'Tipos',
  scopes: 'Ámbitos',
  terms: 'Plazos',
  sources: 'Fuentes',
  'financiadores-estudios': 'Financiadores de Estudios',
  paises: 'Países',
  metrics: 'Métricas',
  'metric-values': 'Valores de Métricas'
});
